import { ControllerHelper, MediaTypeController, UserShortInfoDownloadDto } from "collaboration-service";
import SidebarTitleContainer from "components/Sidebars/SidebarTitleContainer";
import UserSelect, { UserWithCount } from "components/UserSelect";
import { Button } from "imaginarity-react-ui";
import * as _ from "lodash";
import * as React from "react";
import { useImgI18N } from "services/ImgI18N";
import { Itypes } from "views/CMS/CMS";
import FileTypeSelect, { FileTypeWithCount } from "views/CMS/Filter/SubComponents/FileTypeSelect";
import StandardFilter, { GlobalPostSearchFilterProps, StandardFilterMoreFiltersType } from "./StandardFilter";

const CMSFilter = (p: GlobalPostSearchFilterProps) => {
    const { facets, cmsMode, containerRef } = p;
    const { t } = useImgI18N("global");
    const { t: cmsT } = useImgI18N("cms");
    const [types, setTypes] = React.useState<Itypes[]>([]);

    const facetFileTypes = facets?.["fileType"];
    const usersFacets = (facets ?? {})["authorIds"];
    const users = React.useMemo(
        () => _.map(usersFacets, (u) => u.data as string),
        [usersFacets]
    );


    React.useEffect(() => {
        const loadExtensions = async () => {
            const endings = await ControllerHelper.singleCall(
                { mediaTypes: _.map(facetFileTypes, (f) => f.data as string) },
                MediaTypeController.GetFileEndings,
                true
            );
            setTypes(
                _.orderBy(
                    _.map(endings, (end, key) => {

                        return {
                            label: cmsT(key),
                            value: key,
                        };
                    }),
                    (e) => e.label
                )
            );
        };
        loadExtensions();
    }, [facetFileTypes, cmsT]);

    const moreFilters = React.useMemo((): StandardFilterMoreFiltersType => (newFilter, setNewFilter, newFeFilter, setNewFeFilter) => {
        const typeValue = _.map(
            newFilter?.includedFileTypes,
            (f) => _.find(types, (t) => t.value === f)!
        );
        const onChangeTypes = (value: FileTypeWithCount[]) => {
            setNewFilter(f => {
                const toRet = { ...f };
                if (value.length === 0) {
                    delete toRet.includedFileTypes;
                }
                else {
                    toRet.includedFileTypes = _.map(value, (v) => v.value);
                }
                return toRet;
            });
        };
        const user = newFeFilter?.authorId ? { id: newFeFilter.authorId } as UserWithCount : null;
        const onAuthorChanged = (value: UserShortInfoDownloadDto | null) => {
            setNewFeFilter(f => {
                const toRet = { ...f };
                if (value)
                    toRet.authorId = value.id;
                else
                    delete toRet.authorId;
                return toRet;
            });
        };

        return (
            <>
                {cmsMode === "File" &&
                    <>

                        {users && users.length !== 0 &&
                            <>
                                <SidebarTitleContainer icon="filter" title={cmsT("filter by author")} noIcon noBold />
                                <UserSelect
                                    list={users}
                                    value={user ?? null}
                                    isMulti={false}
                                    usersSelected={onAuthorChanged}
                                    counts={usersFacets}
                                    menuPortalTarget={containerRef?.current}
                                />
                            </>
                        }
                        <SidebarTitleContainer icon="filter" title={cmsT("filter file type")} noIcon noBold />
                        <FileTypeSelect
                            fileTypes={types}
                            isMulti
                            onFileTypeChanged={onChangeTypes}
                            value={typeValue}
                            counts={facetFileTypes}
                            specialStyles
                            menuPortalTarget={containerRef?.current}
                        />
                    </>
                }
            </>
        );
    }, [cmsMode, types, facetFileTypes, containerRef, cmsT, usersFacets, users]);

    return (
        <>
            {cmsMode === "File" ?
                <div style={{ padding: "5px 5px 0 5px" }}>
                    <Button kind={"primary"} floated="right" icon="chevron left" fluid content={t("back to cms projects overview")} onClick={() => p.onChangeMode("Project")} />
                </div>
                :
                <div />
            }

            <StandardFilter moreFilters={moreFilters} {...p} hideGroupFilter />
        </>
    );
};

export default CMSFilter;